<template>
  <div class="download-panel hidden-xs-only">
    <transition name="fade" v-if="downloads.length">
      <el-popover placement="bottom" width="250" v-model.trim="show" trigger="click">
        <progress-panel :list="downloads" :isShowPop.sync="show"></progress-panel>
        <div class="download-clear">
          <span @click="clearAll">清除全部任务</span>
        </div>
        <el-badge :value="downloads.length" :max="9" slot="reference">
          <i class="icon icon-download"></i>
          <span>{{$t('download')}}</span>
        </el-badge>
      </el-popover>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ProgressPanel from './progress-panel';

export default {
	name: 'download-panel',
	data() {
		return {
			show: false
		};
	},
	computed: {
		...mapGetters(['downloads'])
	},
	methods: {
		...mapMutations({
			removeDownloads: 'REMOVE_DOWNLOADS'
		}),
		clearAll() {
			this.show = false;
			this.removeDownloads();
		}
	},
	components: {
		ProgressPanel
	}
};
</script>


<style lang="scss" scoped>
.download-panel {
	padding-left: 15px;
	i {
		cursor: pointer;
	}
}
.download-clear {
	display: flex;
	margin-top: 15px;
	height: 20px;
	justify-content: flex-end;
	color: $-theme-color;
}
</style>
